import React, { useEffect, useState } from 'react';
import { DentalTileInformation } from 'src/packages/dental/components/DentalTile';
import { Col, Row } from '@digitools/honest-react';
import { getMemberEvent } from 'src/packages/dental/providers/DentalDataProvider';
import { range } from 'lodash';
import useDentalDataContext from 'src/packages/dental/hooks/useDentalContext';
import { DentalTileContainer, StyledDentalTile } from 'src/packages/dental/styles/DentalStyles';
const onKeyDown = (e, index, tileList, tabRefs, setCurrentIndex) => {
    const tabLength = tileList.length || 0;
    let activeTab;
    if (e.key == 'ArrowLeft') {
        const previousIndex = index - 1;
        activeTab = tabRefs[previousIndex >= 0 ? previousIndex : tabLength - 1]?.current;
    }
    else if (e.key == 'ArrowRight') {
        const nextIndex = index + 1;
        activeTab = tabRefs[nextIndex < tabLength ? nextIndex : 0]?.current;
    }
    if (activeTab) {
        activeTab?.focus();
        setCurrentIndex(index);
    }
    if (e.key == 'Enter' || e.key == 'Space' || e.key == ' ') {
        tabRefs[index]?.current?.click();
    }
};
const onClick = (index, component, setCurrentIndex, setActiveTab, action) => {
    setCurrentIndex(index);
    setActiveTab(component);
    if (action) {
        action();
    }
};
export const TileTabs = ({ id, tileList }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const tabs = Array.from(range(0, tileList.length));
    const [tabRefs, setTabRefs] = useState([]);
    const { setActiveTab, tealiumFunction, subscriber, currentMember } = useDentalDataContext();
    const memberEvent = getMemberEvent(currentMember, subscriber);
    useEffect(() => {
        const refs = tabs.map(() => React.createRef());
        setTabRefs(refs);
    }, []);
    return (<Row data-public={true} id={id} aria-labelledby={`${id}-tab-list`} role={'tablist'}>
      {tileList.map((tile, index) => {
            return (<Col>
            <DentalTileContainer data-public={true}>
              <StyledDentalTile ref={tabRefs[index]} as={'button'} {...{ type: 'button' }} id={tile.component + '-tab-button'} tabIndex={currentIndex == index ? 0 : -1} role={'tab'} aria-selected={currentIndex == index} onKeyDown={e => {
                    onKeyDown(e, index, tileList, tabRefs, setCurrentIndex);
                }} onClick={() => {
                    onClick(index, tile.component, setCurrentIndex, setActiveTab, tile.action);
                }}>
                <DentalTileInformation props={{ component: tile.component, title: tile.title, imageName: tile.imageName }}/>
              </StyledDentalTile>
            </DentalTileContainer>
          </Col>);
        })}
    </Row>);
};
export default TileTabs;
